import { useState, useEffect } from "react";
import { ProdutoNFCeDto } from "../../../NFCe/NFCe.Dto";
import { getLocal, NFeDto, STORAGENFE_KEY, updateLocal } from "../../NFe.Dto";

export function NFeCadastroItemLoad() {
  const [dataProdutoNFe, setDataProdutoNFe] = useState<ProdutoNFCeDto[]>(() => {
    const nf = getLocal<NFeDto>(STORAGENFE_KEY);
    return nf?.itens ?? [];
  });

  useEffect(() => {
    updateLocal<NFeDto>(STORAGENFE_KEY, {
      itens: dataProdutoNFe,
    });
  }, [dataProdutoNFe]);

  return { dataProdutoNFe, setDataProdutoNFe };
}
